import { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';

import { useAuth } from '../../hooks/useAuth';

import SignIn from './signin';
import SignUp from './signup';

import Brand from '../../assets/brand/brand.png';

import './styles.css';

const Auth = () => {
    const { signinWithGoogle } = useAuth();
    const [view, setView] = useState('signin');

    return (
        <div className="auth-container">
            <img src={Brand} alt="" />

            <div className="auth-card">
                {view === 'signin' ? (
                    <SignIn onSwitch={() => setView('signup')} />
                ) : (
                    <SignUp onSwitch={() => setView('signin')} />
                )}

                <div className="auth-divider">
                    <span>ou continue com</span>
                </div>

                <GoogleLogin
                    useOneTap
                    onSuccess={credentialResponse => signinWithGoogle(credentialResponse)}
                    onError={() => console.log('Login Failed')}
                />
            </div>
        </div>
    );
}

export default Auth;